import { forwardRef, type Ref, type SVGProps } from "react";
const IconDogLargeOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M6.87 6.365c-.579 0-1.072.419-1.167.99L3.799 18.826c-.12.72.436 1.377 1.167 1.377H7.51v1.782H4.966a2.965 2.965 0 0 1-2.925-3.45L3.945 7.062a2.965 2.965 0 0 1 2.925-2.48h2.876v1.782zm18.26 0h-2.876V4.583h2.876a2.965 2.965 0 0 1 2.925 2.48l1.904 11.471a2.965 2.965 0 0 1-2.925 3.45h-2.738v-1.781h2.738c.73 0 1.287-.656 1.167-1.377L26.297 7.355a1.18 1.18 0 0 0-1.167-.99"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="m16.147 20.05 3.617 3.421c1.333 1.26 3.527.316 3.527-1.519V10.854a7.291 7.291 0 0 0-14.582 0v11.219c0 1.84 2.189 2.802 3.544 1.556zM16 1.78a9.074 9.074 0 0 0-9.074 9.074v11.219c0 3.392 4.035 5.164 6.533 2.869l2.67-2.455 2.41 2.279c2.47 2.335 6.535.585 6.535-2.814V10.854A9.074 9.074 0 0 0 16 1.78"
      clipRule="evenodd"
    />
    <path d="M17.944 19.927a1.944 1.944 0 1 1-3.888 0 1.944 1.944 0 0 1 3.888 0m-4.536-7.647a1.296 1.296 0 1 1-2.593 0 1.296 1.296 0 0 1 2.593 0m7.777 0a1.296 1.296 0 1 1-2.593 0 1.296 1.296 0 0 1 2.593 0" />
    <path
      fillRule="evenodd"
      d="M12.537 24.828a4.26 4.26 0 0 0 3.495 1.823 4.26 4.26 0 0 0 3.496-1.823l1.46 1.021a6.04 6.04 0 0 1-4.956 2.585 6.04 6.04 0 0 1-4.956-2.585z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconDogLargeOutlineSVG);
ForwardRef.displayName = "IconDogLargeOutline";
export { ForwardRef as IconDogLargeOutline };
